// Core
import { Redirect, Route, Switch } from 'react-router-dom';

// Chakra imports
import { ChakraProvider } from '@chakra-ui/react';

// Assets
import routes from '../routes.js';
import theme from '../theme/theme.js';

// Components
import MainPanel from '../components/Layout/MainPanel';
import PanelContainer from '../components/Layout/PanelContainer';
import PanelContent from '../components/Layout/PanelContent';
import { ReactComponent as Lines } from 'assets/svg/lines.svg';

import background from '../assets/img/clear-layout/bg.png';

export default function Clear(props) {
  const getRoute = () => {
    return window.location.pathname !== '/full-screen-maps';
  };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.category === 'header') {
        return getRoutes(prop.views);
      }
      if (prop.layout === '/clear') {
        //return <Route path={prop.layout + prop.path} component={prop.component} key={key} routes={routes} />;
        return (
          <Route path={prop.layout + prop.path} key={key}>
            {(routerProps) => <prop.component {...routerProps} />}
          </Route>
        );
      } else {
        return null;
      }
    });
  };

  return (
    <ChakraProvider theme={theme} resetCss={false}>
      {/* <Lines
        className="abstract-lines"
        style={{
          transform: 'rotate(-201deg) scale(1)',
          width: '150%',
          height: '150%',
          top: '-300px',
          left: '-30%',
        }}
      /> */}
      <div
        className="clear-layout-background"
        style={{
          backgroundImage: `url(${background})`,
          position: 'fixed',
          width: '100%',
          height: '100%',
        }}
      >
        <MainPanel
          transition="unset !important"
          w={{ base: '100%' }}
          left={{ base: '0' }}
          maxWidth="1158px"
          float="unset"
          alignItems="center"
          justifyContent="center"
          m="0px auto 0 auto"
          overflow="initial"
        >
          {getRoute() ? (
            <PanelContent mt="60px">
              <PanelContainer>
                <Switch>
                  {getRoutes(routes)}
                  <Redirect from="/" to={routes[0].path} />
                </Switch>
              </PanelContainer>
            </PanelContent>
          ) : null}
        </MainPanel>
      </div>
    </ChakraProvider>
  );
}
